var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.9094,
    r: 24.1818,
    fill: "#A8AAAC",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0906 23.109H26.5111V12.5294C26.5111 11.6952 25.834 11.0181 24.9997 11.0181C24.1654 11.0181 23.4883 11.6952 23.4883 12.5294V23.109H12.9088C12.0745 23.109 11.3974 23.7861 11.3974 24.6203C11.3974 25.4546 12.0745 26.1317 12.9088 26.1317H23.4883V36.7112C23.4883 37.5455 24.1654 38.2226 24.9997 38.2226C25.834 38.2226 26.5111 37.5455 26.5111 36.7112V26.1317H37.0906C37.9249 26.1317 38.602 25.4546 38.602 24.6203C38.602 23.7861 37.9249 23.109 37.0906 23.109Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadPdf);
export default __webpack_public_path__ + "static/media/icon-upload-pdf.a8f81400b1656cc527694a262d2b0442.svg";
export { ForwardRef as ReactComponent };